import { authApi } from "@app/api";
import { cacheMinTimer } from "@app/api";

export interface PylonIdentityHashResponse {
  email_hash: string;
}

export interface FetchPylonIdentityHashPayload {
  userId: string;
  email: string;
}

export const fetchPylonIdentityHash = authApi.get<
  FetchPylonIdentityHashPayload,
  PylonIdentityHashResponse
>("/pylon_identity_hash", { supervisor: cacheMinTimer() }, authApi.cache());
